import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import ResultsTable from './Table/ResultsTable';
import ScreeningFrequency from '../Modals/ScreeningFrequency';
import ApprovalStatus from '../Modals/ApprovalStatus';
import ViewHistoryModal from '../Modals/ViewHistoryModal';
import EntriesFilters from './TableFilters/EntriesFilters';
import { Modal } from '@mui/material';
import CasesAPI from 'api/CasesAPI';
import { useHistory } from 'react-router-dom';
import pako from 'pako';
import { Buffer } from 'buffer';
import { exportToCSV } from 'components/Common/CSVManage';
import { useSnackbar } from 'notistack';
import { handleUpdateTicketNotification } from 'utils/NotificationsFuncs';
import { formatDate } from 'utils/dateFormater';
interface IResultsProps {
  cur_user: any;
  cur_case: any;
  trigger: boolean;
  setTrigger: any;
  setShareModal: any;
  setIsCommentsModalOpen: any;
  triggerCSV: boolean;
  setTriggerCSV: any;
  screeningCus: any;
}

const ResultsComponent: React.FC<IResultsProps> = ({ cur_user, cur_case, trigger, setTrigger, setShareModal, setIsCommentsModalOpen, triggerCSV, setTriggerCSV, screeningCus }) => {
  const history = useHistory();
  if (!cur_case) {
    history.push('/bite-monitor');
    return <></>;
  }

  const [ isFrequencyModalOpen, setIsFrequencyModalOpen ] = useState(false);
  const [ isApprovalModalOpen, setIsApprovalModalOpen ] = useState(false);
  const [ isHistoryModalOpen, setIsHistoryModalOpen ] = useState(false);
  const [ activeFilter, setActiveFilter ] = useState(cur_case.data.activeFilter ? cur_case.data.activeFilter : 'BITE Lens');
  const [ selectedOpts, setSelectedOpts ] = useState([]);
  const [ curLevel, setCurLevel ] = useState(1);
  const [ filterOpts, setFilterOpts ] = useState<any>({});
  const [ screenParmsModal, setScreenParamsModal ] = useState(false);
  const [ newTab, setNewTab ] = useState(false);
  const [ curVersion, setCurVersion ] = useState<any>(cur_case.data.results.length > 0 ?
    cur_case.data.results[cur_case.data.results.length - 1] :
    undefined);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ currentItems, setCurrentItems ] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  const decompressData = (compressedData: any) => {
    if (compressedData === undefined || compressedData.length === 0) {
      return {};
    }
    const compressedBuffer = Buffer.from(compressedData[0], 'base64');
    const decompressed = pako.ungzip(compressedBuffer, { to: 'string' });
    return JSON.parse(decompressed);
  };

  const decompData = cur_case.data.results.length > 0 ? decompressData(cur_case.data.results[cur_case.data.results.length - 1].allResults) : [];

  let parsedResults = decompData;
  const [ passedDownResults, setPassedDownResults ] = useState(decompData);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleFrequencyCloseModal = () => {
    setIsFrequencyModalOpen(false);
  };
  const handleApprovalCloseModal = () => {
    setIsApprovalModalOpen(false);
  };
  const handleHistoryCloseModal = () => {
    setIsHistoryModalOpen(false);
  };

  const resetTable = () => {
    setPassedDownResults(parsedResults);
    setCurLevel(1);
    setActiveFilter('BITE Lens');
    setSelectedOpts(filterOpts['BITE Lens']);
  };

  const updateCurrentFilters = async() => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: 'updated the saved filters on the ticket'
    };
    const filterOptsObj = {
      Agency: [ ...filterOpts.Agency ],
      Lens: [ ...filterOpts['BITE Lens'] ],
      List: [ ...filterOpts['List Name'] ],
      Country: [ ...filterOpts['Source Country'] ]
    };
    const update: any = {
      _id: cur_case.data._id,
      selectedOpts: selectedOpts,
      filterOpts: filterOptsObj,
      activeFilter: activeFilter,
      activity: [ ...cur_case.data.activity, actObj ]
    };
    const res = await CasesAPI.updateCase(update);
    if (res?.success) {
      enqueueSnackbar('Filters for this ticket have been saved and will persist until a new save is made or new results are added to the ticket', { variant: 'success' });
      setTrigger(!trigger);
    }
  };

  const changeFreq = async(newFreq: string) => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `changed the frequency of the ticket screening from ${cur_case.data.frequency} to ${newFreq}`
    };
    const update: any = {
      _id: cur_case.data._id,
      frequency: newFreq,
      activity: [ ...cur_case.data.activity, actObj ]
    };
    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
  };

  const changeStatus = async(newStatus: string) => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `changed the status of the ticket from ${cur_case.data.status} to ${newStatus}`,
      timeStamp: Date.now()
    };
    const update: any = {
      _id: cur_case.data._id,
      status: newStatus,
      activity: [ ...cur_case.data.activity, actObj ]
    };
    const res = await CasesAPI.updateCase(update);
    if (res?.success) {
      if (cur_case.data.sharedWith.length > 0 && cur_user.basics.Id === cur_case.data.createdBy) {
        cur_case.data.sharedWith.forEach(async(user: string) => {
          handleUpdateTicketNotification(cur_case.data.ticketName, cur_user, user, cur_case.data._id);
        });
      } else if (cur_case.data.sharedWith.length > 0 && cur_user.basics.Id !== cur_case.data.createdBy) {
        const shareArr = cur_case.data.sharedWith.filter((user: string) => {
          return user !== cur_user.basics.id && user !== cur_user.basics.email;
        });
        shareArr.push(cur_case.data.createdBy);
        shareArr.forEach(async(user: string) => {
          handleUpdateTicketNotification(cur_case.data.ticketName, cur_user, user, cur_case.data._id);
        });
      }
    } else {
      enqueueSnackbar('There was an error updating the status of your ticket', { variant: 'error' });
    }
    setTrigger(!trigger);
  };

  const handleActiveFilterChange = (filter: string) => {
    if (filter !== activeFilter) {
      setSelectedOpts(cur_case.data.activeFilter === filter && cur_case.data.selectedOpts.length > 0 ? cur_case.data.selectedOpts : filterOpts[`${filter}`]);
      setActiveFilter(filter);
      setCurLevel(1);
    }
  };

  const handleFilterClick = () => {
    const res = filterDataByKey(parsedResults, activeFilter, selectedOpts);
    setPassedDownResults(res);
  };

  const handleVisClick = (index: number) => {
    if (currentPage > 1) {
      const updatedResults = passedDownResults.filter((res: any, i: number) => i !== index);
      setPassedDownResults(updatedResults);
      if (currentItems.length <= 1) {
        setCurrentPage(currentPage - 1);
      }
    } else {
      const updatedResults = passedDownResults.filter((res: any, i: number) => i !== index);
      setPassedDownResults(updatedResults);
    }
  };

  const extractValuesByKeys = (data: any[], keys: string[]) => {
    // Initialize an object to store the unique values for each key
    const result = keys.reduce((acc: any, key: string) => {
      acc[key] = [];
      return acc;
    }, {});
    // Iterate over the array of objects
    data.forEach((item) => {
      if (Array.isArray(item.docs)) {
        item.docs.forEach((doc: any) => {
          keys.forEach((key) => {
            if (doc[key] && !result[key].includes(doc[key])) {
              result[key].push(doc[key]);
            }
          });
        });
      }
    });

    return result;
  };

  const filterDataByKey = (data: any, key: string, allowedValues: string[]) => {
    return data?.map((item: any) => {
      if (Array.isArray(item?.docs)) {
        return {
          ...item,
          docs: item?.docs?.filter((doc: any) => allowedValues?.includes(doc[key]))
        };
      }
      return item;
    }).filter((item: any) => item?.docs && item?.docs?.length > 0);
  };


  const getOpts = () => {
    const keysToExtract = [ 'BITE Lens', 'Source Country', 'Agency', 'List Name' ];
    const result = extractValuesByKeys(parsedResults, keysToExtract);

    setFilterOpts(result);
    setSelectedOpts(cur_case.data.selectedOpts.length > 0 ? cur_case.data.selectedOpts : result['BITE Lens']);
  };

  const headers = [ 'Field Input', 'Row #', 'Dataset', 'Total Hits' ];

  const handleCSV = () => {
    if (passedDownResults.length >= 1) {
      exportToCSV(`${cur_case.data.ticketName}.csv`, passedDownResults, headers, 'monitor');
      setTriggerCSV(false);
    } else {
      enqueueSnackbar('No Result Data to Export', { variant: 'error' });
      setTriggerCSV(false);
    };
  };

  const handleVersionChange = (version: any) => {
    setCurVersion(version);
    const data = decompressData(curVersion.allResults);
    parsedResults = data;
    setPassedDownResults(data);
    setIsHistoryModalOpen(false);
  };

  useEffect(() => {
    if (parsedResults.length > 0) {
      getOpts();
    }
  }, []);

  useEffect(() => {
    if (curVersion) {
      setNewTab(false);
      setCurLevel(1);
      const data = decompressData(curVersion.allResults);

      parsedResults = data;
      setPassedDownResults(data);
    }
  }, [ curVersion ]);

  useEffect(() => {
    if (curVersion) {
      if (newTab) {
        setCurLevel(1);
        const data = decompressData(curVersion.newResults);

        parsedResults = data;
        setPassedDownResults(data);
      } else {
        setCurLevel(1);
        const data = decompressData(curVersion.allResults);

        parsedResults = data;
        setPassedDownResults(data);
      }
    }
  }, [ newTab ]);

  useEffect(() => {
    if (Object.keys(parsedResults).length > 0) {
      handleFilterClick();
    }
  }, [ selectedOpts ]);

  useEffect(() => {
    if (triggerCSV) {
      handleCSV();
    }
  }, [ triggerCSV ]);

  return (
    <>
      <div className='results-card-frame'>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
        Last Screen
          </div>
          <div className='results-card-frame-body'>
            {cur_case.data.lastUpdate ? formatDate(cur_case.data.lastUpdate) : formatDate(cur_case.data.createdAt.substring(0, 10))}
          </div>
          <div className='results-card-frame-footer' onClick={() => setIsHistoryModalOpen(true)}>
          View History
          </div>
        </div>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
          Screening Frequency
          </div>
          <div className='results-card-frame-body'>
            {cur_case.data.frequency}
          </div>
          <div className='results-card-frame-footer' onClick={() => setIsFrequencyModalOpen(true)}>
          Change
          </div>
        </div>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
          Status
          </div>
          <div className='results-card-frame-body'>
            <svg xmlns='http://www.w3.org/2000/svg' width='9' height='8' viewBox='0 0 9 8' fill='none' style={{ marginRight: '5px' }}>
              <circle cx='4.5' cy='4' r='3' fill={cur_case.data.status === 'Complete' ? '#BDBEC1' : cur_case.data.status === 'Pending' ? '#FDB022' : cur_case.data.status === 'New Results' ? '#4895EF' : cur_case.data.status === 'Approved' ? '#47CD89' : cur_case.data.status === 'Rejected' ? '#F04438' : '#B67DFF' }/>
            </svg>
            {cur_case.data.status}
          </div>
          <div className='results-card-frame-footer' onClick={() => setIsApprovalModalOpen(true)}>
          Change
          </div>
        </div>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
          Ticket Type
          </div>
          <div className='results-card-frame-body-doc'>
            <div className='results-card-frame-body-texts'>
              {cur_case.data.docType}
            </div>
          </div>
          <div className='results-card-frame-footer' style={{ height: '18px' }}>
            {' '}
          </div>
        </div>
      </div>

      <div className='results-frame'>
        <EntriesFilters
          activeFilter={activeFilter}
          options={activeFilter === 'BITE Lens' ? filterOpts['BITE Lens'] : activeFilter === 'Source Country' ? filterOpts['Source Country'] : activeFilter === 'Agency' ? filterOpts.Agency : filterOpts['List Name']}
          selectedOpts={selectedOpts}
          setSelectedOpts={setSelectedOpts}
          handleFilterChange={handleActiveFilterChange}
          cur_case={cur_case}
          screenParmsModal={screenParmsModal}
          setScreenParamsModal={setScreenParamsModal}
          screeningCus={screeningCus}
        />
        <ResultsTable
          curVersion={curVersion}
          passedDownResults={passedDownResults}
          activeFilter={activeFilter}
          curLevel={curLevel}
          setCurLevel={setCurLevel}
          setIsHistoryModalOpen={setIsHistoryModalOpen}
          handleVisClick={handleVisClick}
          cur_case={cur_case}
          setShareModal={setShareModal}
          setIsCommentsModalOpen={setIsCommentsModalOpen}
          setIsFrequencyModalOpen={setIsFrequencyModalOpen}
          setIsApprovalModalOpen={setIsApprovalModalOpen}
          setScreenParamsModal={setScreenParamsModal}
          handleCSV={() => setTriggerCSV(true)}
          updateFilters={updateCurrentFilters}
          resetTable={resetTable}
          newTab={newTab}
          setNewTab={setNewTab}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          currentItems={currentItems}
          setCurrentItems={setCurrentItems}
        />
      </div>
      <Modal
        open={isFrequencyModalOpen}
        onClose={handleFrequencyCloseModal}
      >
        <ScreeningFrequency
          handleClose={handleFrequencyCloseModal}
          changeFrequency={changeFreq}
          curFreq={cur_case.data.frequency}
        />
      </Modal>
      <Modal
        open={isApprovalModalOpen}
        onClose={handleApprovalCloseModal}
      >
        <ApprovalStatus
          handleClose={handleApprovalCloseModal}
          changeStatus={changeStatus}
          curStatus={cur_case.data.status}
        />
      </Modal>
      <Modal
        open={isHistoryModalOpen}
        onClose={handleHistoryCloseModal}
      >
        <ViewHistoryModal
          handleClose={handleHistoryCloseModal}
          versionsArr={cur_case.data.results}
          handleVersionChange={handleVersionChange}
          curVersion={curVersion}
        />
      </Modal>
    </>
  );
};

export default ResultsComponent;
